<div fxLayout="row">

    <mat-card *ngFor="let product of products">
        <mat-card-title>{{ product.payload.doc.data().productName }}</mat-card-title>
        <mat-card-content>
            <p>{{ product.payload.doc.data().productPrice }}</p>
            <mat-checkbox [checked]="product.payload.doc.data().isStack" [disabled]="true">Stack</mat-checkbox>
        </mat-card-content>
    </mat-card>

</div>